import React from 'react';
import { useSelector } from 'react-redux';
import BackdropLoader from './backdropLoader';

export default function BackdropLoaderProvider() {
  const { open, text } = useSelector(store => store.backdropLoader);
  return <BackdropLoader open={open} text={text} />;
}
